import type { FaireProductEntity } from "../../entity_types/product";

export const p_jhhtyb48k8: FaireProductEntity = {
  token: "p_jhhtyb48k8",
  type: "product",
  name: "Be Steady Essential Oil Rollerball - assembled by survivors",
  brandToken: "b_acbb4naqbw",
  brandName: "Crowned Free",
  imageUrl:
    "https://cdn.faire.com/fastly/75b8e3c04187924806ba0bc33eede799b7401dcdd799b2377a45b67961db378c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c41b391c7db0220d4837a79564e3fd82b765e39a4e97f50196a5886b1824e14.jpeg",
    "https://cdn.faire.com/fastly/c624da7d164b433bd054f2cb39b9c1952ba28641a5a114e48ae95ff5012c23c9.png",
  ],
  priceDollars: 13.86,
  description:
    "Be Steady - Surefooted\n-Made in USA\n-Assembled by survivors and at-risk youth in Michigan\n-Net Wt. 0.34 fl. oz. (10ml)\n\nDIRECTIONS: Apply directly on your chest, torso, back of neck, shoulders, and bottom of feet.\n\nCAUTION: For external use only. Keep out of reach of children. Avoid eyes and other sensitive areas. \n\nSTORAGE: Store at room temperature and avoid direct sunlight. \n\nOn a mission to end human trafficking through ethical fashion and gifts. At Crowned Free, we are committed to raising awareness, providing safe and sustainable jobs to empower survivors, choosing ethical sourcing for our products, and giving back to anti-trafficking organizations both locally and globally.\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:42.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
